import React from 'react';
import { Select as AntdSelect, Tag } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { IoIosArrowDown } from 'react-icons/io';
import styles from './select.module.scss';

const Select = React.forwardRef((props, ref) => {
	const {
		style,
		options,
		placeholder,
		onChange,
		defaultValue,
		multiple,
		showSearch,
		disabled,
		title,
		allowClear,
		onSearch,
		value,
		loading,
		type,
		maxTagCount,
		optionLabelProp,
		optionFilterProp,
		filterOption,
		onClear,
		size,
		popupMatchSelectWidth,
		autoFocus,
		defaultOpen,
		onBlur,
		onKeyDown,
		onInputKeyDown,
		onKeyUp,
		status,
		labelInValue,
	} = props;

	const tagRender = ({ label, closable, onClose }) => {
		const onPreventMouseDown = (event) => {
			event.preventDefault();
			event.stopPropagation();
		};
		return (
			<Tag
				onMouseDown={onPreventMouseDown}
				closeIcon={
					closable ? (
						<CloseOutlined style={{ color: '#fff', fontSize: 10 }} />
					) : null
				}
				onClose={onClose}
				style={{
					margin: 3,
					backgroundColor: '#1677FF',
					color: '#fff',
					borderColor: '#1677FF',
				}}
			>
				{label}
			</Tag>
		);
	};

	const commonProps = {
		ref,
		style: {
			'--ant-border-radius': '2px',
			'--ant-border-radius-sm': '2px',
			'--ant-border-radius-lg': '2px',
			...style,
		},
		options,
		tagRender,
		placeholder,
		onChange,
		defaultValue,
		mode: multiple ? 'multiple' : undefined,
		showSearch,
		disabled,
		allowClear,
		onSearch,
		value,
		loading,
		maxTagCount,
		suffixIcon: <IoIosArrowDown className={styles['suffixicon']} />,
		optionLabelProp,
		optionFilterProp,
		filterOption,
		onClear,
		size,
		popupMatchSelectWidth,
		autoFocus,
		defaultOpen,
		onBlur,
		onKeyDown,
		onInputKeyDown,
		onKeyUp,
		status,
		labelInValue,
	};

	if (type === 'bordered') {
		return (
			<AntdSelect
				{...commonProps}
				className={styles['border-select']}
				popupClassName={styles['border-menu']}
			/>
		);
	}

	return (
		<div className={styles['wrapper']}>
			{title && <p className={styles['title']}>{title}</p>}
			<AntdSelect
				{...commonProps}
				variant="borderless"
				styles={{ root: { backgroundColor: '#f8f8f8' } }}
				className={styles['select']}
				popupClassName={styles['menu']}
			/>
		</div>
	);
});

Select.displayName = 'Select';

export default Select;
